import { render } from "./ListChat.vue?vue&type=template&id=03adb841&scoped=true"
import script from "./ListChat.vue?vue&type=script&lang=js"
export * from "./ListChat.vue?vue&type=script&lang=js"

import "./ListChat.vue?vue&type=style&index=0&id=03adb841&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03adb841"]])

export default __exports__